import { Textarea } from '@/layers/presentation/components/ui/Textarea';
import logger from '@/layers/support/monitoring/logger';
import { NotificationType } from '@/types/modelEnums';
import { Program } from '@/types/models';
import { Button, Modal, ModalBody, ModalContent, useDisclosure } from '@nextui-org/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ProgramPreviewCard from './ProgramPreviewCard';

import { useThrowNotification } from '@/layers/presentation/hooks';
const LOG_MODULE = 'FE [Presentation / Components / ProgramNotRelevant]';

interface ProgramNotRelevantProps {
  program: Program;
  typeUrl: string;
}

const ProgramNotRelevant: React.FC<ProgramNotRelevantProps> = ({ program, typeUrl }) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const throwNotification = useThrowNotification();

  const handleButtonClick = () => {
    onOpen();
  };

  const handleSubmit = () => {
    logger.info(`${LOG_MODULE} Submitting not relevant program ${program.id}`);
    onClose();
    throwNotification(NotificationType.Success, t('components:programCard.notRelevantSubmitted'));
  };

  return (
    <div>
      <Button size="sm" radius="sm" variant="bordered" onClick={handleButtonClick}>
        {t('components:programCard.notRelevant')}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalContent>
          <ModalBody className="p-10">
            <h2>Mark program as not relevant</h2>
            <ProgramPreviewCard
              program={program}
              typeUrl={typeUrl}
              onCardPress={() => {}}
              isLoadingProgram={false}
              isShowDetailsButton={false}
            />
            <Textarea
              label="Reason"
              placeholder="Why do you think this program is not relevant?"
              className="mt-8"
            />
            <Button size="md" radius="md" color="primary" onClick={handleSubmit} className="mt-4">
              {t('components:programCard.notRelevantSubmit')}
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default ProgramNotRelevant;
